<template>
  <div class="bg-daner">
    <ul class="h-100 m-0">
      <li class=" d-flex align-items-center">
        <b-link class="container-menu-toggle-navbar d-xl-none mr-1" @click="toggleVerticalMenuActive">
          <feather-icon
            icon="MenuIcon"
            size="25"
          />
        </b-link>
        <b-link
          class="navbar-brand mr-1"
          :to="checkRedirect()"
        >
          <span class="brand-logo d-flex align-items-center">
            <b-img
              v-if="checkOutHome()"
              fluid
              src="@/assets/images/logo/ooh.avif"
              alt="Logo"
              style="max-width: 100px"
            />
            <b-img
              v-else
              :src="is_whitelabel_and_has_logo ? verifyAsset(user_data.whitelabel_settings.logo) : require('@/assets/images/logo/logo-brandme.png')"
              alt="Logo"
              style="max-width: 100px; max-height: 43px"
              :key="update_image"
              @error="handleImageError"
            />
          </span>
        </b-link>
        <div v-if="routePath() && !checkOutHome()">
          <div class="container-search" :class="{'expanded': is_search_expanded}">
            <div class="position-relative">
              <b-form-input
                class="input-search-proposal"
                :placeholder="user_data && (user_data.main_group.name === 'creator') ? $t('creator.placeholder_suggestions_creator') : $t('creator.placeholder_suggestions_brand')"
                v-model="search"
                @keyup.enter="searchQuery()"
                @click="expandSearch"
                trim
                @focus="focusActionInput"
                @blur="blurActionInput"
                autocomplete="off"
              > 
              </b-form-input>
              <div class="container-icon-search" @click="handleSearchClick">
                <b-icon
                  class="icon-search"
                  icon="search"
                ></b-icon>
              </div>
              <b-icon
                class="icon-close"
                icon="x"
                @click="collapseSearch"
              ></b-icon>
            </div>
            <suggestions-container 
              :show_suggestions="show_suggestions"
              :key="update_suggestions"
              :list_selected="button_Selected"
            />
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { 
  BLink,
  BFormInput,
  BImg,
} from 'bootstrap-vue';
import suggestionsContainer from '@/views/components/proposals/suggestionsContainer.vue';
import { getUserData, updateWhitelabelSettings } from '@/libs/utils/user';
import { getLogo } from '@/services/settings';
import { verifyAsset } from '@/libs/utils/urls';

export default {
  components: {
    BLink,
    BFormInput,
    BImg,
    suggestionsContainer
  },
  data() {
    return {
      verifyAsset,
      search: this.$route.query.query ? this.$route.query.query : '',
      show_suggestions: false,
      update_suggestions: false,
      user_data: getUserData(),
      is_creator: this.user_data && this.user_data.is_superuser ? this.user_data.main_group.name === 'creator' : false,
      button_Selected: {
        selected: false,
        type_button: '',
        list_button: [],
      },
      update_image: false,
      is_search_expanded: false,
    }
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  created () {
    this.rutaDominio = window.location.host;
    this.$root.$on('update_color_button_selected', (selected_Button) => {
      this.button_Selected = selected_Button;
    });
    this.$root.$on('update_search_query', (search) => {
      this.search = search;
    });
    this.$root.$on('whitelabel_logo_updated', () => {
      // force re-fetch user data to get updated logo
      this.user_data = getUserData();
      // force component re-render
      this.update_image = !this.update_image;
    });
  },
  computed: {
    has_a_plan_or_is_creator() {
      if (getUserData() && getUserData().main_group && getUserData().main_group.name === 'creator') return true
      return getUserData() && getUserData().current_plan.name !== 'Free'
    },
    is_whitelabel_and_has_logo() {
      return this.user_data?.whitelabel_settings?.logo || false;
    }
  },
  methods: {
    handleImageError(event) {
      getLogo().then(response => {
        this.user_data.whitelabel_settings.logo = response.logo_url;
        updateWhitelabelSettings(this.user_data.whitelabel_settings);
        event.target.src = response.logo_url;
      }).catch(() => {
        event.target.src = require('@/assets/images/logo/logo-brandme.png');
      });
    },
    focusActionInput() {
      if (!this.has_a_plan_or_is_creator) return;
      this.show_suggestions = true; 
      this.update_suggestions = !this.update_suggestions;      
    },
    routePath() {
      if (!this.$route.fullPath.includes('home-search') && !this.$route.fullPath.includes('email-confirm') &&  !this.$route.fullPath.includes('additional-information') && !this.$route.fullPath.includes('/roll')) {
        return true
      }
    },
    checkOutHome() {
      return this.rutaDominio.includes('outofhome')
    },
    checkRedirect() {
      if (this.checkOutHome()) return '/campaigns'
      else if (this.is_creator || this.checkCreatorPublicViews()) return '/home-search';
      return '/'
    },
    checkCreatorPublicViews() {
      
      if (!getUserData()) {
        return true
      } else if (getUserData()) {
        return true
      } else {
        return false  
      }
    },
    expandSearch() {
      if (window.innerWidth < 1200) {
        this.is_search_expanded = true;
      }
    },
    collapseSearch() {
      this.is_search_expanded = false;
      if (this.has_a_plan_or_is_creator) {
        this.show_suggestions = false; 
        this.update_suggestions = !this.update_suggestions;
      }
      this.search = '';
    },
    handleSearchClick() {
      if (window.innerWidth < 1200 && !this.is_search_expanded) {
        this.expandSearch();
      } else {
        this.searchQuery();
      }
    },
    searchQuery() {
      if (!this.user_data || (this.user_data.main_group.name !== 'creator')) {
        (this.search.length > 0) ? this.$router.push({name: 'creadores', query: {query: this.search}}) : this.$router.push({name: 'creadores'})
        this.$root.$emit('update_proposals');
      } else if (this.user_data.main_group.name === 'creator') {
        (this.search.length > 0) ?  this.$router.push({name: 'marcas', query: {query: this.search}}) : this.$router.push({name: 'marcas'})
        this.$root.$emit('update_casting_calls');
      }
    },
    blurActionInput() {
      if (this.has_a_plan_or_is_creator) {
        setTimeout(() => {        
          this.show_suggestions = false;
          this.update_suggestions = !this.update_suggestions;
        }, 200);
      }
    },
    clickOnNetwork(net) {
      this.$router.push({name: 'creadores', query: {network: net}}); 
      this.$root.$emit('update_proposals');
    }
  }
}
</script>

<style scoped lang="scss">
.container-menu-toggle-navbar {
  color: var(--header-text) !important;
  border-radius: 10px;
  padding: 11px;
  &:hover {
    background-color: var(--header-text-hover);
  }
}
.container-search {
  transition: all 0.3s ease-in-out;
  width: 340px;
  position: fixed;
  top: 16px;

  &.expanded {
    .icon-close {
      visibility: visible;
      opacity: 1;
      pointer-events: auto;
      transition-delay: 0.3s, 0s;
    }
  }
  @media(max-width: 1199px) {
    &.expanded {
      z-index: 1050;
      width: 60%;

      .input-search-proposal {
        width: 100% !important;
        padding-left: 2.4em !important;
        padding-right: 2.4em !important;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
        
        &::placeholder {
          opacity: 1 !important;
        }
      }
    }
  }
  @media(max-width: 767px) {
    &.expanded {
      width: 65%;
    }
  }

  @media(max-width: 630px) {
    &.expanded {
      width: 90%;
      transition: all 1s ease-in-out;
      left: 20px;
    }
  }
  
  .icon-close {
    position: absolute;
    color: #6c757d;
    z-index: 8;
    top: 0.5em;
    right: 0.5em;
    font-size: 20px;
    cursor: pointer;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 50%;
    padding: 2px;
    pointer-events: none;
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.2s ease-in-out, visibility 0s linear 0.2s;
    
    &:hover {
      color: #495057;
    }
  }
}

.container-search .input-search-proposal { 
  border-radius: 1.357rem;
  padding-left: 2.4em;
  // width: 400px;
  height: 38px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  @media(max-width: 1199px) {
    width: 38px;
    padding-left: 0;

    &::placeholder {
      opacity: 0;
    }
  }
}
.container-icon-search {
  display: flex;
  justify-content: center;
  position: absolute;
  color: #6c757d;
  background-color: wite;
  border-radius: 100%;
  height: 38px;
  width: 38px;
  z-index: 8;
  top: 0em;
  left: 0em;
  
  align-items: center;
  cursor: pointer;
  .icon-search {
    font-size: 18px;
  }
}
.float-suggestions-search {
  width: 100%;
  height: auto;
  background-color: white;
  border-radius: 1em;
  padding: 1em;
  position: absolute;
  top: 3.5em;
  z-index: 100;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}
.badge-float-suggestions {
  background-color: #f1f1f1 !important;
  color: #444;
  cursor: pointer;
}
.badge-float-suggestions:hover {
  background-color: #e2e2e2 !important;
}
.img-network-badge {
  width: 18px;
  height: 18px;
}
</style>
